export const bakeSummary = (state, updatedAt) => {
    const revision = state.snapshot?.revisions.formula;
    return {
        bakeId: state.bakeId,
        status: state.status,
        version: state.version,
        ...(revision === undefined ? {} : { recipeId: revision.id, recipeVersion: revision.version }),
        ...(state.startedAt === undefined ? {} : { startedAt: state.startedAt }),
        ...(state.endedAt === undefined ? {} : { endedAt: state.endedAt }),
        updatedAt,
    };
};
//# sourceMappingURL=summary.js.map